import { ClinicalRelationships } from '../../../../../../constants';
import { PARENT_GUARDIAN_CLINICAL_RELATIONSHIPS } from './constants';

import type { ITreatmentPlanV3InformationPage } from '../../../../../../store/treatmentPlanV3';
import type { IProviderAssignment } from '../../../../../../utils/types';
import type { InformationAssignmentEntry } from '../types';

// BCBAs arrive as three separate fields; the card shows them as one list keyed by role.
export function getInformationBcbaEntries(
  page: ITreatmentPlanV3InformationPage | null,
): InformationAssignmentEntry[] {
  if (!page) return [];

  const entries: InformationAssignmentEntry[] = [];
  if (page.home_bcba) {
    entries.push({
      id: `home-${page.home_bcba.provider_id}`,
      name: page.home_bcba.display_name ?? '',
      role: 'Home',
    });
  }
  if (page.bobbing_bcba) {
    entries.push({
      id: `bobbing-${page.bobbing_bcba.provider_id}`,
      name: page.bobbing_bcba.display_name ?? '',
      role: 'Bobbing',
    });
  }
  page.substitute_bcbas.forEach((bcba) => {
    entries.push({
      id: `substitute-${bcba.provider_id}`,
      name: bcba.display_name ?? '',
      role: 'Substitute',
    });
  });

  return entries;
}

export function getInformationBtEntries(
  page: ITreatmentPlanV3InformationPage | null,
): InformationAssignmentEntry[] {
  if (!page) return [];

  return page.assigned_bts.map((bt) => ({
    id: `bt-${bt.provider_id}`,
    name: bt.display_name ?? '',
    role: 'BT',
  }));
}

export function getInformationParentGuardianEntries(
  assignments: IProviderAssignment[],
  clientId: number | null,
): InformationAssignmentEntry[] {
  if (clientId == null) return [];

  return assignments.flatMap((assignment) => {
    if (assignment.client.id !== clientId || assignment.id == null) return [];

    const relationship = PARENT_GUARDIAN_CLINICAL_RELATIONSHIPS.find(
      (value) => value === assignment.clinical_relationship,
    );
    if (!relationship) return [];

    return [
      {
        id: String(assignment.id),
        name: [assignment.provider.first_name, assignment.provider.last_name]
          .filter(Boolean)
          .join(' '),
        role: relationship === ClinicalRelationships.PracticingGuardian ? 'Guardian' : 'Parent',
      },
    ];
  });
}
